const Accordion = (({ jQuery: $ }) => {
    class Accordion {
        constructor(node) {
            this.$drawer = $(node);
            this.$header = this.$drawer.children('a');
            this.$subMenu = this.$drawer.children('.sub-menu');
            this.headerHeight = null;
            this.expandedSize = null;
            this.hasInitialized = false;
            this.isOpenState = false;
            this.activeClass = 'js-is-active';
        }

        getExpandedSizes() {
            this.headerHeight = this.$header.outerHeight();
            this.expandedSize =
                this.$drawer[0].scrollHeight + this.$subMenu[0].clientHeight;
        }

        setCollapsedHeight() {
            this.$drawer.css('max-height', this.headerHeight);
        }

        setExpandedHeight() {
            this.$drawer.css('max-height', this.expandedSize);
        }

        openFirstDrawer() {
            this.$header.addClass('open');
            this.$drawer.addClass('open');
            this.setExpandedHeight();
        }

        closeOtherDrawers() {
            this.$drawer
                .siblings()
                .find('a.' + this.activeClass)
                .trigger('click');
        }

        toggleDrawer(e) {
            e.preventDefault();
            this.$header.toggleClass(this.activeClass);
            this.$drawer.toggleClass(this.activeClass);

            if (this.isOpenState == false) {
                this.$drawer.css('max-height', this.expandedSize);
                this.closeOtherDrawers();
            } else {
                this.setCollapsedHeight();
            }

            //invert the state to toggle state
            this.isOpenState = !this.isOpenState;
        }

        cloneParentLink() {
            let clickClone = this.$drawer[0].cloneNode(true);

            clickClone.setAttribute(
                'id',
                clickClone.getAttribute('id') + '-clone'
            );

            clickClone.querySelector('.sub-menu').remove();

            this.$subMenu[0].prepend(clickClone);
        }

        addEventListeners() {
            this.$header.on('touchend click', this.toggleDrawer.bind(this));
            $(window).on('resize', this.checkScreenSize.bind(this));

            if (this.hasInitialized) {
                $(window).off('resize');
            }
        }

        shouldInit() {
            if (window.innerWidth < 1170) {
                /* go ahead and init at 1170 px or lower,
                this prevents FOUC at the real breakpoint (1024 px) */
                return true;
            }
        }

        checkScreenSize() {
            if (this.hasInitialized) {
                return;
            } else if (this.shouldInit()) {
                this.init();
            }
        }

        init() {
            if (!this.shouldInit()) {
                return;
            }
            this.addEventListeners();
            this.getExpandedSizes();
            this.setCollapsedHeight();
            this.cloneParentLink();
            this.hasInitialized = true;
            /* once this module has initialized once
            it stops adding event listeners and checking screen size*/
        }
    }

    return {
        init({ selector }) {
            return new Accordion(selector).init();
        },
    };
})(window);

export default Object.create(Accordion);
